import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { VALUE_TYPES } from '@ispm/dynamic-form/constants/value-type.enum';
import {ELEMENT_INDEX_MAX, ELEMENT_INDEX_MIN, ITEMS_TYPES} from '@ispm/dynamic-form/constants/ItemsTypes';
import { get, has } from 'lodash';

export function getValueTypeByItem(item: IdynamicFormItem): VALUE_TYPES {
  switch ((<string> item.type).toUpperCase()) {
    case ITEMS_TYPES.UPLOAD:
      return VALUE_TYPES.OBJECT;

    case ITEMS_TYPES.TOGGLE:
      return VALUE_TYPES.ARRAY;

    case ITEMS_TYPES.TEXTAREA:
    case ITEMS_TYPES.TEXT:
    case ITEMS_TYPES.TEXT_MULTILINES:
    case ITEMS_TYPES.RADIO:
      return VALUE_TYPES.STRING;

    case ITEMS_TYPES.CHECKBOX:
      if (get(item, 'attributes[\'[binary]\'', false)) {
        return VALUE_TYPES.BOOLEAN;
      } else {
        return VALUE_TYPES.STRING;
      }

    case ITEMS_TYPES.TOGGLE_SWITCH:
      return VALUE_TYPES.BOOLEAN;

    case ITEMS_TYPES.NUMBER:
      return VALUE_TYPES.NUMBER;

    case ITEMS_TYPES.AUTOCOMPLETE:
    case ITEMS_TYPES.DROPDOWN:
    case ITEMS_TYPES.SELECT:
    case ITEMS_TYPES.MULTISELECT:
    case ITEMS_TYPES.MULTISELECT_WITH_MANUAL:
      if (Array.isArray(item.options.values)) {
        return typeof item.options.values[0] === 'string'
          ? VALUE_TYPES.STRING
          : VALUE_TYPES.OBJECT;
      } else {
        return item.options.resource && item.options.resource.includes('=IGNORE')
          ? VALUE_TYPES.STRING
          : VALUE_TYPES.OBJECT;
      }

    case ITEMS_TYPES.WIDGET:
      return getWidgetValueType(item.options.component.toUpperCase(), item.widgetPayload);
    default:
      return VALUE_TYPES.OBJECT;
  }
}

function getWidgetValueType(component: string, widgetPayload: any) {
  switch (component.toUpperCase()) {
    case 'DYNAMICFORMTABLE':
    case 'DYNAMICFORMTABLECOMPONENT':
    case 'PRIORITYTABLECOMPONENT':
    case 'GROUPTABLECOMPONENT':
    case 'ARRAYAPPENDER':
    case 'ARRAYAPPENDERCOMPONENT':
      return VALUE_TYPES.ARRAY;
    case 'NUMBEROFINPUT':
    case 'NUMBEROFINPUTCOMPONENT':
      return VALUE_TYPES.OBJECT;
    case 'RICHNOTESCOMPONENT':
    case 'RICHNOTES':
      return VALUE_TYPES.OBJECT;
    default:
      return VALUE_TYPES.OBJECT;
  }
}

export function getRandomInt():string {
  const min = Math.ceil(ELEMENT_INDEX_MIN);
  const max = Math.floor(ELEMENT_INDEX_MAX);
  return Math.floor(Math.random() * (max - min + 1) + min).toString(); //The maximum is inclusive and the minimum is inclusive
}
